/*
 * Shadeward vehicle size picker — see PRODUCT-PAGE-UPDATE-PLAN.md + SIZE-PICKER-PLAN.md
 * Make -> Model -> Year lookup against assets/fitment_data.json, drives the theme
 * quantity_break per-unit Size <select> and owns Add to Cart submission so each unit
 * carries its own line-item properties. Every size CTA on the page scrolls here.
 * No dependencies.
 */
(function () {
  'use strict';

  var root = document.getElementById('shadeward-fit-picker');
  if (!root) return;

  // ---------- config ----------
  var FITMENT_URL = root.getAttribute('data-fitment-url');
  var SIZE_POS = parseInt(root.getAttribute('data-size-option-position'), 10) || 1;
  var LS_KEY = 'sunshade_vehicle';

  var variants = [];
  try { variants = JSON.parse(root.querySelector('.sw-variants-data').textContent); }
  catch (e) { variants = []; }

  // Runtime copy comes from snippets/size-picker.liquid (locales/*.json ->
  // shadeward.fit_picker.*). English defaults keep the picker usable if the blob
  // is ever missing. Placeholders are [n] / [unit] / [letter] / [year] / [make] /
  // [model] / [vehicle].
  var I18N = {
    unit_label: 'Umbrella #[n]',
    second_car: 'Now the second car — whose is it?',
    third_car: 'And the third:',
    choosing_for: 'Choosing for [unit].',
    select_model: 'Select model',
    select_year: 'Select year',
    match_found: '✓ Your [year] [make] [model] takes size [letter]',
    size_selected: 'Size [letter] selected for [unit].',
    needs_xl: "Your [vehicle] needs our XL size — and it's sold out right now.",
    find_by_car: 'Find the right size for your car',
    reopen_short: 'Pick by car',
    atc_error: 'Sorry — this size could not be added to the cart.',
    size_set: 'Size [letter] set for [unit].'
  };
  try {
    var i18nBlob = root.querySelector('[data-sw-i18n]');
    if (i18nBlob) {
      var parsed = JSON.parse(i18nBlob.textContent);
      Object.keys(I18N).forEach(function (k) {
        if (parsed[k]) I18N[k] = parsed[k];
      });
    }
  } catch (e) {}

  // t('match_found', { '[letter]': 'M' }) -> the string with its markers filled in.
  function t(key, replacements) {
    var out = I18N[key] || '';
    if (replacements) {
      Object.keys(replacements).forEach(function (marker) {
        out = out.split(marker).join(replacements[marker]);
      });
    }
    return out;
  }

  var fitment = null;
  var fitmentPromise = null;
  var targetUnit = 1;
  var swSetting = false;
  var unitState = {}; // unit -> { size, vehicle, source }

  // ---------- helpers ----------
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function pushDL(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: name };
      if (data) { for (var k in data) { if (data.hasOwnProperty(k)) p[k] = data[k]; } }
      window.dataLayer.push(p);
    } catch (e) {}
  }

  function letterFromValue(val) {
    var v = String(val == null ? '' : val).trim().toUpperCase();
    if (v === 'S' || v === 'SMALL') return 'S';
    if (v === 'M' || v === 'MEDIUM') return 'M';
    if (v === 'L' || v === 'LARGE') return 'L';
    if (v.charAt(0) === 'S' || v.charAt(0) === 'M' || v.charAt(0) === 'L') return v.charAt(0);
    return null;
  }
  function optionValueForLetter(selectEl, letter) {
    for (var i = 0; i < selectEl.options.length; i++) {
      if (letterFromValue(selectEl.options[i].value) === letter) return selectEl.options[i].value;
    }
    return null;
  }
  function variantIdForLetter(letter) {
    var any = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (letterFromValue(v['option' + SIZE_POS]) === letter) {
        if (any === null) any = v.id;
        if (v.available !== false) return v.id;
      }
    }
    return any;
  }

  // ---------- quantity_break DOM ----------
  function selectedQty() {
    var inp = document.querySelector('.quantity-break-option.selected input');
    var q = inp ? parseInt(inp.value, 10) : 1;
    return isNaN(q) ? 1 : Math.max(1, q);
  }
  function unitSelect(qty, unit) {
    return document.querySelector(
      '.quantity-break-variant-select[data-quantity-option="' + qty +
      '"][data-item-index="' + unit +
      '"][data-option-selector="' + SIZE_POS + '"]');
  }
  function selectBundle(qty) {
    var opts = $all('.quantity-break-option');
    for (var i = 0; i < opts.length; i++) {
      var inp = opts[i].querySelector('input');
      if (inp && parseInt(inp.value, 10) === qty) { opts[i].click(); return true; }
    }
    return false;
  }

  // ---------- applying a size ----------
  function applySizeToUnit(unit, letter, meta) {
    var qty = selectedQty();
    if (unit > qty) unit = qty;
    var sel = unitSelect(qty, unit);
    if (sel) {
      var val = optionValueForLetter(sel, letter);
      if (val != null) {
        swSetting = true;
        sel.value = val;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        swSetting = false;
      }
    }
    unitState[unit] = {
      size: letter,
      vehicle: (meta && meta.vehicle) || null,
      source: (meta && meta.source) || 'picker'
    };
    persist();
    syncCartInputs();
    revealATC();
  }

  function revealATC() {
    var qty = selectedQty();
    var ready = true;
    for (var u = 1; u <= qty; u++) { if (!unitState[u]) { ready = false; break; } }
    document.documentElement.classList.toggle('sw-atc-ready', ready);
  }

  function reapplyToSelects() {
    var qty = selectedQty();
    for (var u = 1; u <= qty; u++) {
      if (!unitState[u]) continue;
      var sel = unitSelect(qty, u);
      if (!sel) continue;
      var val = optionValueForLetter(sel, unitState[u].size);
      if (val != null && sel.value !== val) {
        swSetting = true;
        sel.value = val;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        swSetting = false;
      }
    }
  }

  // ---------- persistence ----------
  function persist() {
    try {
      var qty = selectedQty();
      var units = [];
      for (var u = 1; u <= qty; u++) units[u - 1] = unitState[u] || null;
      localStorage.setItem(LS_KEY, JSON.stringify({ qty: qty, units: units }));
    } catch (e) {}
  }
  function restore() {
    var data;
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return;
      data = JSON.parse(raw);
    } catch (e) { return; }
    if (!data || !data.units || !data.units.length) return;
    if (data.qty && data.qty !== selectedQty()) selectBundle(data.qty);
    var qty = selectedQty();
    var n = Math.min(qty, data.units.length);
    for (var u = 1; u <= n; u++) {
      var st = data.units[u - 1];
      if (st && st.size) unitState[u] = st;
    }
    reapplyToSelects();
    revealATC();
  }

  // ---------- fitment data ----------
  function ensureFitment() {
    if (fitment) return Promise.resolve(fitment);
    if (fitmentPromise) return fitmentPromise;
    fitmentPromise = fetch(FITMENT_URL)
      .then(function (r) { return r.json(); })
      .then(function (raw) { fitment = normalize(raw); return fitment; })
      .catch(function () { fitment = {}; return fitment; });
    return fitmentPromise;
  }
  // Merge case-duplicate makes (BMW/Bmw, GMC/Gmc); prefer the ALL-CAPS display.
  function normalize(raw) {
    var groups = {};
    Object.keys(raw).forEach(function (mk) {
      var key = mk.toLowerCase();
      (groups[key] = groups[key] || []).push(mk);
    });
    var out = {};
    Object.keys(groups).forEach(function (key) {
      var keys = groups[key], display = null;
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === keys[i].toUpperCase()) { display = keys[i]; break; }
      }
      if (!display) display = keys[0];
      var models = {};
      keys.forEach(function (mk) {
        Object.keys(raw[mk]).forEach(function (mdl) {
          models[mdl] = (models[mdl] || []).concat(raw[mk][mdl]);
        });
      });
      out[display] = models;
    });
    return out;
  }
  function coversYear(run, y) { return y >= run[0] && y <= run[1]; }
  // Make -> Model -> Year cascade.
  function allMakes() {
    return Object.keys(fitment).sort(function (a, b) { return a.localeCompare(b); });
  }
  function modelsForMake(make) {
    return Object.keys(fitment[make] || {}).sort(function (a, b) { return a.localeCompare(b); });
  }
  function yearsForModel(make, model) {
    var runs = (fitment[make] || {})[model] || [];
    var seen = {};
    runs.forEach(function (r) {
      for (var y = r[0]; y <= r[1]; y++) seen[y] = true;
    });
    return Object.keys(seen)
      .map(function (y) { return parseInt(y, 10); })
      .sort(function (a, b) { return b - a; }); // newest first
  }
  function lookupSize(make, model, year) {
    var runs = (fitment[make] || {})[model];
    if (!runs) return null;
    for (var i = 0; i < runs.length; i++) { if (coversYear(runs[i], year)) return String(runs[i][2]).trim(); }
    return null;
  }

  // ---------- DOM refs ----------
  var openBtn = $('[data-sw-open]');
  var panel = $('#sw-panel');
  var yearSel = $('[data-sw-year]');
  var makeSel = $('[data-sw-make]');
  var modelSel = $('[data-sw-model]');
  var targetNote = $('[data-sw-target-note]');
  var cards = {
    found: $('[data-sw-card="found"]'),
    na: $('[data-sw-card="na"]'),
    notlisted: $('[data-sw-card="notlisted"]')
  };

  var makesFilled = false;
  function fillMakes() {
    ensureFitment().then(function () {
      if (makesFilled) return;
      fillOptions(makeSel, allMakes());
      makeSel.disabled = false;
      makesFilled = true;
    });
  }
  function resetSelect(sel, ph) {
    sel.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = ph; sel.appendChild(o);
  }
  function fillOptions(sel, values) {
    var frag = document.createDocumentFragment();
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v; o.textContent = v; frag.appendChild(o);
    });
    sel.appendChild(frag);
  }
  function hideCards() { cards.found.hidden = true; cards.na.hidden = true; cards.notlisted.hidden = true; }
  function unitLabel() { return t('unit_label', { '[n]': targetUnit }); }
  function updateTargetNote() {
    if (selectedQty() > 1) {
      targetNote.textContent = targetUnit === 2 ? t('second_car')
        : targetUnit === 3 ? t('third_car') : t('choosing_for', { '[unit]': unitLabel() });
      targetNote.hidden = false;
    } else { targetNote.hidden = true; }
  }

  // ---------- open / scroll / pulse ----------
  function openPanel() {
    panel.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    updateTargetNote();
    fillMakes();
  }
  function scrollToPicker() {
    try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { root.scrollIntoView(); }
    root.classList.remove('sw-pulse');
    // reflow to restart the animation, then add
    void root.offsetWidth;
    root.classList.add('sw-pulse');
    setTimeout(function () { root.classList.remove('sw-pulse'); }, 2400);
  }
  function openPickerForUnit(unit) {
    targetUnit = unit;
    hideCards();
    openPanel();
    pushDL('size_picker_opened', { unit: unit });
    scrollToPicker();
  }
  function resetFlow() {
    hideCards();
    makeSel.value = '';
    resetSelect(modelSel, t('select_model')); modelSel.disabled = true;
    resetSelect(yearSel, t('select_year')); yearSel.disabled = true;
    openPanel();
  }

  // ---------- outcomes ----------
  function showFound(year, make, model, letter) {
    hideCards();
    $('[data-found-title]').textContent = t('match_found', {
      '[year]': year, '[make]': make, '[model]': model, '[letter]': letter
    });
    $('[data-found-sub]').textContent = t('size_selected', { '[letter]': letter, '[unit]': unitLabel() });
    cards.found.hidden = false;
    applySizeToUnit(targetUnit, letter, { vehicle: year + ' ' + make + ' ' + model, source: 'picker' });
  }
  function showNA(vehicle) {
    hideCards();
    $('[data-na-title]').textContent = t('needs_xl', { '[vehicle]': vehicle });
    var vf = $('[data-sw-na-vehicle]');
    if (vf) vf.value = 'XL restock request — Vehicle: ' + vehicle + '. Notify me when the XL size is back in stock.';
    cards.na.hidden = false;
  }
  function showNotListed(vehicle) {
    hideCards();
    var vf = $('[data-sw-fit-vehicle]');
    if (vf) vf.value = 'Fitment request — please size this vehicle: ' + vehicle + '.';
    // collapse the measure sub-panel each time
    var mp = $('[data-sw-measure]'); if (mp) mp.hidden = true;
    var mt = $('[data-sw-measure-toggle]'); if (mt) mt.setAttribute('aria-expanded', 'false');
    var done = $('[data-manual-done]'); if (done) { done.hidden = true; done.textContent = ''; }
    $all('.sw-size-btn', cards.notlisted).forEach(function (b) { b.classList.remove('is-active'); });
    cards.notlisted.hidden = false;
  }

  function handleResult(make, model, year) {
    pushDL('vehicle_selected', { year: year, make: make, model: model });
    var vehicle = year + ' ' + make + ' ' + model;
    var size = lookupSize(make, model, year);

    if (size === null) { // year out of range for a listed model
      pushDL('size_result', { size: 'NA' });
      pushDL('fitment_gap', { vehicle: vehicle });
      showNotListed(vehicle);
      return;
    }
    if (size.indexOf('/') >= 0) { // compound -> manual check
      pushDL('size_result', { size: 'compound' });
      pushDL('fitment_gap', { vehicle: vehicle });
      showNotListed(vehicle);
      return;
    }
    if (size.toUpperCase() === 'NOT AVAILABLE') { // waitlist only
      pushDL('size_result', { size: 'NA' });
      showNA(vehicle);
      return;
    }
    var letter = letterFromValue(size);
    if (!letter) { showNotListed(vehicle); return; }
    pushDL('size_result', { size: letter });
    showFound(year, make, model, letter);
  }

  // ---------- per-unit triggers ----------
  function injectTriggers() {
    $all('.sw-unit-trigger').forEach(function (b) {
      if (!b.parentNode) return;
      if (b.parentNode.classList) b.parentNode.classList.remove('sw-has-unit-trigger');
      b.parentNode.removeChild(b);
    });
    var qty = selectedQty();
    for (var u = 1; u <= qty; u++) {
      var sel = unitSelect(qty, u);
      if (!sel) continue;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sw-link sw-unit-trigger';
      btn.textContent = (u === 1 ? t('find_by_car') : t('reopen_short'));
      btn.setAttribute('data-unit', String(u));
      btn.addEventListener('click', function () { openPickerForUnit(parseInt(this.getAttribute('data-unit'), 10)); });
      sel.insertAdjacentElement('afterend', btn);
      // Lets size-picker.css relax the quantity_break cell that now holds two children.
      if (sel.parentNode && sel.parentNode.classList) sel.parentNode.classList.add('sw-has-unit-trigger');
    }
  }

  // ---------- Add to Cart ----------
  // This theme ships several competing submit handlers (product-form.js,
  // shop-cart-button-handler.js, and quantity_break's own) that conflict and can
  // silently break Add to Cart. We take ONE clean pass: set the variant id +
  // properties on the form, then own the submit (blocking the others), post the
  // form's own data, and open the cart drawer — falling back to /cart, and
  // surfacing any real Shopify error instead of failing silently.
  // Match the action loosely: Shopify can prefix it with a locale/market path
  // (e.g. /en-gb/cart/add) or suffix it with .js, so an exact string misses.
  function productForm() { return document.querySelector('form[action*="/cart/add"]'); }

  function setHiddenProp(form, name, value) {
    var el = form.querySelector('input[data-sw-prop="' + name + '"]');
    if (!value) { if (el && el.parentNode) el.parentNode.removeChild(el); return; }
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.setAttribute('data-sw-prop', name);
      el.name = 'properties[' + name + ']';
      form.appendChild(el);
    }
    el.value = value;
  }

  function syncCartInputs() {
    var form = productForm();
    if (!form) return;
    var qty = selectedQty();
    // Single unit: set the variant id + Fit/_Vehicle so the theme's add carries
    // them. (Bundles: quantity_break builds its own line items, so single-unit
    // props don't apply there — clear them.)
    if (qty === 1 && unitState[1]) {
      var st = unitState[1];
      var id = variantIdForLetter(st.size);
      var idInput = form.querySelector('input[name="id"]');
      if (id && idInput) idInput.value = id;
      setHiddenProp(form, 'Fit', st.size + ' — ' + (st.source === 'picker' ? 'matched to your car' : 'manually selected'));
      setHiddenProp(form, '_Vehicle', (st.source === 'picker' && st.vehicle) ? st.vehicle : '');
    } else {
      setHiddenProp(form, 'Fit', '');
      setHiddenProp(form, '_Vehicle', '');
    }
  }

  // Open the cart drawer WITHOUT depending on the add-to-cart response shape.
  // The theme's renderContents() is brittle (it throws on an internal jQuery
  // slider init and only opens inside a setTimeout), so instead we re-fetch the
  // drawer markup the same way the theme's quantity_break code does, swap it in,
  // and call the drawer's own open(). Only truly-no-drawer bounces to /cart.
  function openDrawerOrCart() {
    var cartBase = (window.routes && window.routes.cart_url) || '/cart';
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) { window.location.href = cartBase; return; }
    fetch(cartBase + '?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawer');
          var current = drawer.querySelector('#CartDrawer');
          if (fresh && current && current.parentNode) current.parentNode.replaceChild(fresh, current);
        } catch (e) {}
        if (drawer.classList) drawer.classList.remove('is-empty');
        updateCartCount();
        try { if (typeof drawer.open === 'function') drawer.open(); } catch (e) {}
      })
      .catch(function () {
        try { if (typeof drawer.open === 'function') { drawer.open(); return; } } catch (e) {}
        window.location.href = cartBase;
      });
  }

  function updateCartCount() {
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var span = document.querySelector('.cart-count-bubble span[aria-hidden="true"]') ||
                   document.querySelector('.cart-count-bubble span');
        if (span) span.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  function onCartSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    // Own it cleanly and stop the theme's other (conflicting) submit handlers.
    e.preventDefault();
    e.stopImmediatePropagation();

    var qty = selectedQty();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    function reset() { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } }
    // Always hit the JSON endpoint (.js) so the response is JSON, never a 302
    // to /cart that would blow up r.json(). Keep any locale/market prefix.
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var addUrl = base.indexOf('.js') >= 0 ? base : base + '.js';

    syncCartInputs();

    var request;
    if (qty > 1) {
      // Bundle: one line item per unit, its size from the select (fallback to the
      // form's default variant so the add never dies), with per-unit properties.
      var defInput = form.querySelector('input[name="id"]');
      var defId = defInput ? parseInt(defInput.value, 10) : null;
      var items = [];
      for (var i = 1; i <= qty; i++) {
        var sel = unitSelect(qty, i);
        var letter = sel ? letterFromValue(sel.value) : (unitState[i] ? unitState[i].size : null);
        var vid = (letter && variantIdForLetter(letter)) || defId;
        if (!vid) continue;
        var props = {};
        var st = unitState[i];
        if (st) {
          props['Fit'] = st.size + ' — ' + (st.source === 'picker' ? 'matched to your car' : 'manually selected');
          if (st.source === 'picker' && st.vehicle) props['_Vehicle'] = st.vehicle;
        }
        items.push({ id: vid, quantity: 1, properties: props });
      }
      request = fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      });
    } else {
      // Single: post the form's OWN data (correct variant id + our hidden props +
      // quantity). No dependency on variant lookup — the add can't come up empty.
      var fd = new FormData(form);
      request = fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
    }

    request
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || (res.body && res.body.status)) {
          reset();
          var msg = (res.body && (res.body.description || res.body.message)) || t('atc_error');
          window.alert(msg);
          return;
        }
        pushDL('add_to_cart', { units: qty });
        reset();
        openDrawerOrCart();
      })
      .catch(function () {
        // A hiccup adding to cart shouldn't dump the shopper on /cart — the item
        // usually still landed, so refresh + open the drawer instead of redirecting.
        reset();
        openDrawerOrCart();
      });
  }

  // ---------- every size CTA -> the picker ----------
  function goToPicker(e) {
    if (e) { try { e.preventDefault(); e.stopImmediatePropagation(); } catch (x) {} }
    openPanel();
    scrollToPicker();
  }
  function wireCtas() {
    // anchor links (fit-section "Find My Size" button, FAQ #1 link)
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href="#shadeward-fit-picker"], a[href$="#shadeward-fit-picker"]') : null;
      if (a) goToPicker(e);
    }, true);
    // guarantee section CTA (hardcoded href="#")
    $all('.guarantee-section__cta').forEach(function (b) {
      b.addEventListener('click', goToPicker, true);
    });
    // sticky add-to-cart buttons (must not add the default variant)
    ['stickyAddToCartBtn', 'stickyAddToCartBtnMobile'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.addEventListener('click', goToPicker, true);
    });
  }

  // ---------- wire everything ----------
  function wire() {
    openBtn.addEventListener('click', function () {
      if (panel.hidden) { openPickerForUnit(targetUnit); }
      else { panel.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); }
    });

    // Make -> Model -> Year cascade. Changing Make resets Model + Year;
    // changing Model resets Year.
    makeSel.addEventListener('change', function () {
      hideCards();
      resetSelect(modelSel, t('select_model')); modelSel.disabled = true;
      resetSelect(yearSel, t('select_year')); yearSel.disabled = true;
      var make = makeSel.value;
      if (!make) return;
      var models = modelsForMake(make);
      if (!models.length) { showNotListed(make); return; }
      fillOptions(modelSel, models); modelSel.disabled = false;
    });

    modelSel.addEventListener('change', function () {
      hideCards();
      resetSelect(yearSel, t('select_year')); yearSel.disabled = true;
      var make = makeSel.value, model = modelSel.value;
      if (!make || !model) return;
      var years = yearsForModel(make, model);
      if (!years.length) { showNotListed(make + ' ' + model); return; }
      fillOptions(yearSel, years.map(String)); yearSel.disabled = false;
    });

    yearSel.addEventListener('change', function () {
      var make = makeSel.value, model = modelSel.value, year = parseInt(yearSel.value, 10);
      if (!make || !model || !year) return;
      handleResult(make, model, year);
    });

    $('[data-sw-notlisted]').addEventListener('click', function () {
      var mk = makeSel.value, md = modelSel.value, yr = yearSel.value;
      var vehicle = ((yr ? yr + ' ' : '') + [mk, md].filter(Boolean).join(' ')).trim() || 'unlisted vehicle';
      pushDL('fitment_gap', { vehicle: vehicle });
      showNotListed(vehicle);
    });

    // measure-guide toggle inside the not-listed card
    var mToggle = $('[data-sw-measure-toggle]');
    if (mToggle) mToggle.addEventListener('click', function () {
      var mp = $('[data-sw-measure]');
      var open = mp.hidden;
      mp.hidden = !open;
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // reset links (delegated)
    root.addEventListener('click', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-sw-reset]')) resetFlow();
    });

    // manual size buttons
    $all('[data-sw-manual]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var letter = this.getAttribute('data-sw-manual');
        $all('.sw-size-btn', cards.notlisted).forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        applySizeToUnit(targetUnit, letter, { source: 'manual', vehicle: null });
        var done = $('[data-manual-done]');
        if (done) { done.textContent = t('size_set', { '[letter]': letter, '[unit]': unitLabel() }); done.hidden = false; }
      });
    });

    // email analytics (forms post normally to the store contact email)
    var wf = $('.sw-waitlist-form');
    if (wf) wf.addEventListener('submit', function () {
      var vf = $('[data-sw-na-vehicle]'); pushDL('xl_waitlist_signup', { vehicle: vf ? vf.value : '' });
    });
    var ff = $('.sw-fitment-form');
    if (ff) ff.addEventListener('submit', function () {
      var vf = $('[data-sw-fit-vehicle]'); pushDL('fitment_request', { vehicle: vf ? vf.value : '' });
    });

    // manual selection directly on a quantity_break select
    document.addEventListener('change', function (e) {
      var sel = e.target;
      if (!sel || !sel.classList || !sel.classList.contains('quantity-break-variant-select')) return;
      if (swSetting) return;
      var qty = selectedQty();
      if (parseInt(sel.getAttribute('data-quantity-option'), 10) !== qty) return;
      var unit = parseInt(sel.getAttribute('data-item-index'), 10);
      var letter = letterFromValue(sel.value);
      if (!unit || !letter) return;
      unitState[unit] = { size: letter, vehicle: null, source: 'manual' };
      persist(); syncCartInputs(); revealATC();
    }, true);

    // bundle switching
    document.addEventListener('quantity_break:changed', function () {
      var qty = selectedQty();
      Object.keys(unitState).forEach(function (k) { if (parseInt(k, 10) > qty) delete unitState[k]; });
      if (targetUnit > qty) targetUnit = qty;
      injectTriggers(); reapplyToSelects(); syncCartInputs(); revealATC(); updateTargetNote();
    });

    // Own the Add to Cart submit (capture phase, before the theme's handlers).
    document.addEventListener('submit', onCartSubmit, true);

    wireCtas();
    injectTriggers();
    restore();
    syncCartInputs();
    revealATC();

    // The picker starts open (the markup ships without `hidden`); this fills the Make
    // list and syncs the button's aria-expanded / the per-unit note.
    openPanel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();
